import { MouseEventHandler, useEffect, useRef } from 'react';
import { LabelButton, SortIndicator } from '.';

export const FocusLabelButton = ({
  name,
  label,
  sortBy,
  sortDirection,
  onClick,
}: {
  name: string;
  label: string;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
}) => {
  const inputEl = useRef(null);

  useEffect(() => {
    inputEl.current &&
      name === sortBy &&
      (inputEl.current as HTMLButtonElement).focus();
  }, [name, sortBy, sortDirection]);

  return (
    <LabelButton onClick={onClick} ref={inputEl}>
      <span>{label}</span>

      <SortIndicator
        name={name}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />
    </LabelButton>
  );
};
